import { Button, Typography } from "@mui/joy";
import {
  alpha,
  darken,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import React from "react";
import { useSearchParams } from "react-router-dom";
import { MissionMap } from "../entities/missionMap";
import DialogClose from "../hooks/DialogClose/dialogClose";
import { useMissionMap } from "../templates/projectInvite";

export function OnboardingRequiredDialog({
  open,
  onClose,
  mission,
}: {
  open: boolean;
  onClose: () => void;
  mission: MissionMap;
}) {
  return (
    <DialogClose
      sx={{ zIndex: 99999 }}
      BackdropProps={{
        sx: {
          backdropFilter: "blur(8px)",
          backgroundColor: darken(
            alpha(
              mission?.CompanyColor ? mission.CompanyColor : "#101B2E",
              0.5,
            ),
            0.8,
          ),
        },
      }}
      onClose={onClose}
      open={open}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle sx={{ background: mission?.CompanyColor }}>
        {mission?.CompanyLogo ? (
          <img
            style={{ margin: "auto", display: "block" }}
            src={mission.CompanyLogo}
            alt="Company Logo"
            height={50}
          />
        ) : null}
      </DialogTitle>
      <DialogContent
        sx={{
          textAlign: "center",
          gap: 2,
          display: "flex",
          flexDirection: "column",
          mt: 2,
        }}
      >
        <i
          style={{
            fontSize: "92px",
            opacity: 0.7,
            marginTop: 8,
            marginBottom: 8,
          }}
          className="fa-duotone fa-solid fa-file-contract"
        ></i>
        <Typography level="title-lg">
          A contract for the <i>{mission?.SeasonName}</i> is ready to sign
        </Typography>
        <Typography level="body-sm">
          Before you can sign it, please complete your onboarding to: securely
          share your tax detail, link your banking information and sign a W9.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          color="success"
          endDecorator={
            <i className="fa-solid fa-arrow-up-right-from-square"></i>
          }
          sx={{ mb: 2, mt: 2 }}
          onClick={() => mission?.onboardNow()}
        >
          Onboard now
        </Button>
      </DialogActions>
    </DialogClose>
  );
}

/**
 *
 * @returns {ReactElement} OnboardingRequired page
 */
export function OnboardingRequired() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const mission = useMissionMap(token!);
  const [dismissed, setDismissed] = React.useState(false);

  if (!mission) return null;

  return (
    <OnboardingRequiredDialog
      open={Boolean(!dismissed && mission?.onboardingRequired())}
      onClose={() => setDismissed(true)}
      mission={mission}
    />
  );
}
